const modulePaymentSel = (state: any) => state.payments;

export const dataSel = (state: any): any[] => modulePaymentSel(state).data;
export const pageNumberSel = (state: any) => modulePaymentSel(state).pageNumber;
export const pageSizeSel = (state: any) => modulePaymentSel(state).pageSize;
export const totalElementsSel = (state: any) =>
  modulePaymentSel(state).totalElements;
export const totalPagesSel = (state: any) => modulePaymentSel(state).totalPages;

export const errorSel = (state: any) => modulePaymentSel(state).error;
export const isPendingSel = (state: any) => modulePaymentSel(state).isPending;
